export default "/images/4c6bfd6e6ec0bfc1fda0e94949fe58df.png";